// Central static content for site sections
import { Mail, Phone, MapPin, Award, Heart, Shield } from 'lucide-react';

export const NAV_SECTIONS = [
  { id: 'touche-collab', label: 'TOUCHE COSMETICS' },
  { id: 'about', label: 'ABOUT' },
  { id: 'resources', label: 'RESOURCES' },
  { id: 'contact', label: 'CONTACT' },
];

export const COLLECTIONS = [
  { id: 'bow-ties', label: 'Bow Ties' },
  { id: 'neckties', label: 'Neckties' },
  { id: 'new-arrivals', label: 'New Arrivals' },
  { id: 'best-sellers', label: 'Best Sellers' },
];

export const CONTACT_INFO = [
  { icon: Mail, title: 'Email', lines: ['Mensbowtie@yahoo.com'], note: 'Best way to reach for inquiries' },
  { icon: Phone, title: 'Phone', lines: ['757-469-9975'], note: 'Call or text for consultations' },
  { icon: MapPin, title: 'Based In', lines: ['Salt Lake City, Utah', 'Serving Clients Nationwide'], note: '' },
];

export const SOCIAL_LINKS = [
  { id: 'facebook', label: 'Facebook', handle: 'Johnnie Mayo', url: 'https://www.facebook.com/search/top?q=Johnnie%20Mayo' },
  { id: 'instagram', label: 'Instagram', handle: '@jmayo1059', url: 'https://www.instagram.com/jmayo1059' },
  { id: 'tiktok', label: 'TikTok', handle: '@carguy1059', url: 'https://www.tiktok.com/@carguy1059' },
];

export const SERVICES = [
  { title: 'Online Consultations', description: 'Virtual styling sessions and product recommendations' },
  { title: 'At-Home Service Shows', description: 'Private viewings and personalized shopping experiences' },
  { title: 'Event Bookings', description: 'Special appearances and bow tie showcases' },
];

export const ABOUT_VALUES = [
  {
    icon: Award,
    title: 'Craftsmanship',
    description: 'Every bow tie tells a story. Decades of experience in selecting the finest materials and perfecting the art of style.',
  },
  {
    icon: Heart,
    title: 'Timeless Style',
    description: 'From 1977 to today, committed to helping gentlemen look and feel their absolute best for every occasion.',
  },
  {
    icon: Shield,
    title: 'Expert Guidance',
    description: 'Professional advice on wardrobe building, style selection, and creating looks that make lasting impressions.',
  },
];

export const TYING_STEPS = [
  {
    title: 'Start with the Right Length',
    description: 'Drape the bow tie around your neck with the right end hanging about 1.5 to 2 inches lower than the left end.',
  },
  {
    title: 'Cross and Loop',
    description: 'Cross the longer end over the shorter end, then bring it up through the loop around your neck, creating a simple knot (similar to the first step of tying your shoes).',
  },
  {
    title: 'Form the Front Bow',
    description: 'Take the shorter end and fold it horizontally to create the front loop of the bow. Place your finger on the fold to hold it in place.',
  },
  {
    title: 'Bring Down the Longer End',
    description: 'Drop the longer end straight down over the center of the bow you just created.',
  },
  {
    title: 'Create the Second Loop',
    description: 'Fold the hanging end back towards your chest and push it through the loop behind the front bow. This creates the back loop of your bow tie.',
  },
  {
    title: 'Tighten and Adjust',
    description: 'Hold the front of the bow tie with one hand and pull on the loops with the other to tighten. Adjust both ends until the bow is symmetrical and sits comfortably at your collar.',
  },
];

export const PRO_TIPS = [
  'Practice in front of a mirror until muscle memory takes over',
  'A slightly imperfect bow tie looks more authentic and distinguished',
  "Start with a larger, butterfly-style bow tie as they're easier to work with",
  "Don't be discouraged - even experienced wearers sometimes need multiple attempts",
];
